import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleX as faSolidCircleX } from "@fortawesome/pro-solid-svg-icons";
import { faVirus as faRegularVirus } from "@fortawesome/pro-regular-svg-icons";

import FileIcon from "../../FileIcon";
import UploadBar from "./UploadBar";
import MarkdownTranslation from "../../MarkdownTranslation";
import { FileData } from "../../../../@types/files";

interface UploadedFileTypes {
  file: FileData & { extension: string };

  remove(...args: unknown[]): unknown;

  storageDirectory?: string;
  isImage?: boolean;
}

function UploadedFile({
  file,
  remove,
  storageDirectory = "files",
  isImage = false,
}: UploadedFileTypes) {
  const handleRemoveClick = (e) => {
    e.preventDefault();
    const criteria = file.id ? { id: file.id } : { clientId: file.clientId };
    remove(criteria);
  };

  return (
    <div className="stack-container upload-status p-0!">
      <div className="stack-item upload-progress">
        <UploadBar progress={file.progress} state={file.state} />
      </div>
      <div className="stack-item z-50">
        <div className="grid grid-cols-[auto_1fr_auto] gap-1 items-center p-1">
          {file.state === "quarantine" ? (
            <>
              <FontAwesomeIcon icon={faRegularVirus} className="fa-lg mr-2" />
              <span className="font-bold">
                {I18n.t("js.files.uploader.error_quarantine")}
              </span>
              <span className="text-muted truncate flex-1">{file.name}</span>
            </>
          ) : (
            <>
              {isImage && file.id ? (
                <img
                  className="max-h-12 max-w-12"
                  src={`/api/storage/${storageDirectory}/${file.id}/${
                    storageDirectory === "images" ? "get/200x200" : "preview"
                  }`}
                />
              ) : (
                <FileIcon extension={file.extension} />
              )}
              <span className="text-muted truncate flex-1">{file.name}</span>
            </>
          )}

          {file.status ? (
            <MarkdownTranslation
              translation={`js.files.uploader.error_code_${file.status}`}
              options={{
                defaults: [{ scope: "js.files.uploader.error_code_unknown" }],
              }}
            />
          ) : null}

          <a
            href="#remove"
            className="remove text-muted px-2 self-stretch flex items-center"
            onClick={handleRemoveClick}
            data-id={file.id}
            title={I18n.t("js.remove")}
          >
            <FontAwesomeIcon icon={faSolidCircleX} size="sm" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default UploadedFile;
